import {useTranslation} from 'react-i18next';
import {Page} from '../../common/constant/page';
import SettingItemV4 from '../../commonSub/component/SettingItemV4';
import SettingItemWrapperV4 from '../../commonSub/component/SettingItemWrapperV4';
import {ISettingItem} from '../../commonSub/type';
import MoreContainerV4 from '../component/MoreContainerV4';

interface IProps {
  isWebview: boolean;
}

export default function ServiceInformationV4({isWebview}: IProps) {
  const {t} = useTranslation();

  return (
    <MoreContainerV4 isWebview={isWebview}>
      <SettingItemWrapperV4>
        {SERVICE_INFORMATION.map(({topText, ...props}) => (
          <SettingItemV4 key={topText} {...props} topText={t(topText)} />
        ))}
      </SettingItemWrapperV4>
    </MoreContainerV4>
  );
}

const TERMS: ISettingItem = {
  type: 'arrow',
  topText: 'more_serviceinfo_terms',
  pageInfo: {page: Page.MorePolicy},
};

const BUSINESS: ISettingItem = {
  type: 'arrow',
  topText: 'more_serviceinfo_business',
  pageInfo: {
    page: Page.MoreBusiness,
  },
};

const SERVICE_INFORMATION = [TERMS, BUSINESS];
